import { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import Footer from "./Footer";
import AppRoutes from "../routes/AppRoutes";

export default function Layout() {
     const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

     const toggleSidebar = () => {
          setIsSidebarExpanded(!isSidebarExpanded);
     };

     return (
          <div id="wrapper">
               <Sidebar
                    isExpanded={isSidebarExpanded}
                    setIsExpanded={setIsSidebarExpanded}
               />
               {/* 👇 sidebar sibling so CSS "~" works */}
               <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                         <Topbar onToggleSidebar={toggleSidebar} />
                         <div className="container-fluid">
                              <AppRoutes />
                         </div>
                    </div>
                    <Footer />
               </div>
          </div>
     );
}